module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-800italic.a69f0add.woff";